import { EntityId } from "@reduxjs/toolkit";
import axios from "axios";

export interface Message {
  id: EntityId;
  senderName: string;
  senderEmailAdd: string;
  message: string;
}

export const messagesAPI = {
  async fetchData() {
    return (
      await axios.get<Message[]>(
        `${process.env.REACT_APP_BACKEND_URL ?? ""}/messages`,
        { withCredentials: true }
      )
    ).data;
  },
  async postMessage(message: Omit<Message, "id">) {
    await axios.post<Message>(
      `${process.env.REACT_APP_BACKEND_URL}/messages`,
      message
    );
  },
  async deleteMessage(id: EntityId) {
    await axios.delete<Message>(
      `${process.env.REACT_APP_BACKEND_URL}/messages/${encodeURIComponent(id)}`,
      {
        withCredentials: true,
      }
    );
    return id;
  },
};
